<script>
    import httpService from '@/services/core/http.service';
    import AdminGrid from '@/components/shared/AdminGrid';
    import { DxColumn, DxItem } from 'devextreme-vue/data-grid';
    import modalService from '@/services/core/modal.service';
    import ConfirmModal from '@/components/modals/ConfirmModal';
    import DemoSettingsModal from '@/components/modals/demo/DemoSettingsModal';
    import Spinner from '@/components/shared/Spinner.vue';

    export default {
        components: {
            AdminGrid,
            DxColumn,
            DxItem,
            Spinner
        },
        data() {
            return {
                dataSource: httpService.getDxDataSource('demo-settings/grid'),
                isLoading: false
            };
        },
        methods: {
            add() {
                modalService.show(DemoSettingsModal, {
                    onSuccess: () => {
                        this.$refs['demoSettingsGrid'].refresh();
                    }
                });
            },
            remove(item) {
                modalService.show(ConfirmModal, {
                    title: 'Delete Entity',
                    msg: `Are you sure you want to DELETE the config?`,
                    btnTextOk: 'Delete',
                    onSuccess: () => {
                        const url = `demo-settings/${item.id}`;
                        httpService.delete(url).then(() => {
                            this.$refs['demoSettingsGrid'].refresh();
                        });
                    }
                });
            },
            run() {
                this.isLoading = true;
                var grid = this.$refs['demoSettingsGrid'];
                const url = `demo-settings/run`;
                httpService
                    .post(url)
                    .then(() => {
                        grid.refresh();
                    })
                    .finally(() => (this.isLoading = false));
            }
        }
    };
</script>

<template>
    <div class="main-content-header">
        <h3>
            <i class="bi bi-card-checklist"></i>
            Demo Sync Settings
        </h3>
    </div>
    <div class="main-content-body">
        <Spinner :show="isLoading" text="Syncing..." style="padding-top: 25% !important" />
        <AdminGrid v-if="!isLoading" :data-source="dataSource" storage-key="demo-settings" ref="demoSettingsGrid">
            <template #toolbar>
                <DxItem location="after" widget="dxButton" :options="{ text: 'Add', onClick: add }" />
                <DxItem location="after" widget="dxButton" :options="{ text: 'Run', onClick: run }" />
            </template>
            <DxColumn data-field="originalCompany" caption="Original Company" />
            <DxColumn data-field="originalBattery" caption="Original Battery" />
            <DxColumn data-field="company" caption="Demo Company" />
            <DxColumn data-field="destinationBattery" caption="Demo Battery" />
            <DxColumn data-field="lastSyncDate" caption="Last Sync Date" data-type="date" format="MM-dd-yyyy HH:mm" />
            <template #actions="{ item }">
                <button type="button" class="btn btn-link py-0 lh-1 text-danger" title="Delete" @click="remove(item.data)">
                    <i class="bi bi-trash"></i>
                </button>
            </template>
        </AdminGrid>
    </div>
</template>
